import { render, staticRenderFns } from "./mobile-signature.vue?vue&type=template&id=4679d218&scoped=true&"
import script from "./mobile-signature.vue?vue&type=script&lang=ts&"
export * from "./mobile-signature.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-signature.vue?vue&type=style&index=0&id=4679d218&prod&lang=less&scoped=true&"
import style1 from "./mobile-signature.vue?vue&type=style&index=1&id=4679d218&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679d218",
  null
  
)

export default component.exports